export default "__VITE_PUBLIC_ASSET__d8760a1c__"